<template>
  <q-dialog ref="docModal" maximized v-model="isVisible">
    <q-layout view="Lhh lpR fff" container class="bg-white">
      <q-header>
        <q-toolbar>
          <q-toolbar-title>{{ translatedTitle }}</q-toolbar-title>
          <q-btn v-if="fileName" flat @click="handleDownload" icon="get_app" />
          <q-btn flat @click="closeModalFile" icon="close" />
        </q-toolbar>
      </q-header>
      <q-page-container>
        <q-page padding style="max-height: 60vh;" class="scroll">
          <component
            :is="computedComponent"
            :src="source"
            v-if="source && computedComponent"
          />
        </q-page>
      </q-page-container>
    </q-layout>
  </q-dialog>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { PdfViewer } from 'jtech-webcomps/src/components/jtech-docs/pdf'
import { DocxViewer } from 'jtech-webcomps/src/components/jtech-docs/docx'
import { QImg } from 'quasar'
import { downloadFile } from './ServiceRequestAttachmentDownload'

@Component({
  name: 'ServiceRequestAttachmentModal',
  components: { PdfViewer, DocxViewer, QImg },
  props: {
    title: {
      type: String,
      default: 'FILES'
    }
  }
})
class ServiceRequestAttachmentModal extends Vue {
  isVisible = false
  source = ''
  extension = ''
  fileName = ''
  fileBlob = null
  pageCount = 0
  currentPage = 1
  extensions = { pdf: 'pdf', jpg: 'jpg', png: 'png', jpeg: 'jpeg', doc: 'doc', xls: 'xls' }

  get computedComponent () {
    if (this.extension === this.extensions.pdf) {
      return PdfViewer
    }
    if (
      this.extension === this.extensions.jpg ||
      this.extension === this.extensions.png ||
      this.extension === this.extensions.jpeg
    ) {
      return QImg
    }
    if (this.extension === this.extensions.doc || this.extension === this.extensions.xls) return DocxViewer
    return null
  }

  get renderModalFile () {
    return this.visible
  }

  set renderModalFile (value) {
    this.$emit('update:visible', value)
  }

  async show (params, nmIdentificacaoParserFile) {
    if (!params || !nmIdentificacaoParserFile) {
      this.$messageBox.error('Invalid parameters to display the file.')
      return
    }

    try {
      this.extension = params.name.split('.')[1]
      this.fileName = params.name

      const file = await nmIdentificacaoParserFile(params.name)
      this.fileBlob = file

      const reader = new FileReader()
      reader.onload = () => {
        this.source = reader.result
        this.isVisible = true
      }
      reader.readAsDataURL(file)
    } catch (error) {
      this.$messageBox.error(`Fail to load file: ${error.message}`)
    }
  }

  closeModalFile () {
    this.isVisible = false
    this.source = ''
    this.extension = ''
    this.fileName = ''
    this.fileBlob = null
  }

  handleDownload () {
    try {
      downloadFile(this.fileBlob, this.fileName)
    } catch (error) {
      this.$messageBox.error(error.message || 'An unexpected error occurred during download.')
    }
  }

  get translatedTitle () {
    return this.$gettext(this.title)
  }
}

export default ServiceRequestAttachmentModal
</script>

<style lang="stylus" scoped>
.q-btn {
  float: right;
}
</style>
